import React from "react";
import Storage from "../../utils/storage";
import { connect } from "react-redux";
import Write from "../../assets/assets/write.svg";
import Dummy from "../../assets/assets/account.svg";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { downloadSDK } from "../../redux/Actions/GetDocsActions";

export const UserInfo = ({
  isGetting,
  status,
  defaultApp,
  dashboardData,
  getStatusSuccess,
  downloadSDK,
  isDownloading,

}) => {

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;
  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const updatingStatusDefault =
    defaultApp && defaultApp[0] && defaultApp[0].nibss_super_admin_status;
  const updatingStatusDefault2 =
    defaultApp && defaultApp[0] && defaultApp[0].status;
  const statusUpdate = defaultApp && defaultApp[0] && defaultApp[0].update;
  const appType = status && status[0] && status[0].application_type;
  // console.log({statusUpdate, userType})


  const downloadLibrary = () => {
    downloadSDK()
  };

  return (
    <div>
      <div className="dashboard-header">
        <div className="dashboard-header-user-info">
          <div className="user-info-image">
            <img src={img || compImg || Dummy} alt="pic" />
          </div>
          <div className="user-info-names">
            <p>Welcome,</p>
            <h2>{name || username}</h2>
            {getStatusSuccess === true && (
              <h4>
                Acceptance Status:
                {updatingStatus === "approved" &&
                  updatingStatus2 !== "rejected" && (
                    <span className="approved">{updatingStatus}</span>
                  )}
                {updatingStatus === "pending" &&
                  updatingStatus2 !== "rejected" && (
                    <span className="pending">{updatingStatus}</span>
                  )}
                {(updatingStatus === "rejected" ||
                  updatingStatus2 === "rejected") && (
                  <span className="rejected">Rejected</span>
                )}
                {(updatingStatus === "certfication_requirements_in_progress" ||
                  updatingStatus2 ===
                    "certfication_requirements_in_progress") && (
                  <span className="pending">Certification in progress</span>
                )}
                {dashboardData && dashboardData.length === 0 && (
                  <span className="pending">No application yet</span>
                )}
              </h4>
            )}
          </div>
        </div>

        <div className="dashboard-header-right">
          {userType !== "staff" && <span>Want to apply for products?</span>}
          {userType !== "staff" && statusUpdate === true && (
            <Link to="/update">
              <button
                disabled={
                  (appType === "default" &&
                    updatingStatusDefault === "pending" &&
                    updatingStatusDefault2 === "approved") ||
                  (updatingStatusDefault === "pending" &&
                    updatingStatusDefault2 === "pending") ||
                  isGetting
                }
              >
                <img src={Write} alt="icon" /> &nbsp; UPDATE
              </button>
            </Link>
          )}

          {userType !== "staff" && !statusUpdate && (
            <Link to="/confirmation">
              <button
                disabled={
                  (updatingStatusDefault === "pending" &&
                    updatingStatusDefault2 === "approved") ||
                  (updatingStatusDefault === "pending" &&
                    updatingStatusDefault2 === "pending") ||
                  isGetting
                }
              >
                <img src={Write} alt="icon" /> &nbsp; APPLY
              </button>
            </Link>
          )}
          <button style={{marginLeft: "1rem"}} onClick={downloadLibrary} disabled={isDownloading}>    {isDownloading ? 'Downloading...' : 'Download SDK'}</button>
        </div>
      </div>
    </div>
  );
};


const mapDispatchToProps = (dispatch) => ({
  downloadSDK: (fileVersion) => dispatch(downloadSDK(fileVersion)),
});

const mapStateToProps = (state) => {
  return {
    isDownloading: state.docs.isDownloading,
    downloadError: state.docs.downloadError
  };
};

UserInfo.propTypes = {
  isGetting: PropTypes.bool,
  status: PropTypes.array,
  defaultApp: PropTypes.array,
  dashboardData: PropTypes.array,
  getStatusSuccess: PropTypes.bool,
  downloadSDK: PropTypes.func,
  isDownloading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
